import { render, staticRenderFns } from "./OrganizerSelection.vue?vue&type=template&id=6c76d0a2&"
import script from "./OrganizerSelection.vue?vue&type=script&lang=js&"
export * from "./OrganizerSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports